import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    addImageContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 24,
      cursor: 'pointer',
      width: 'fit-content',
    },
    addImageText: {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '14px',
      color: STYLE.COLOR.ACCENT_PRIMARY,
      marginLeft: 8,
    },
    imagePreviewContainer: {
      display: 'flex',
      flexDirection: 'row',
      gap: 16,
      flexWrap: 'wrap',
    },
    imagePreview: {
      position: 'relative',
      borderRadius: 16,
      height: 148,
      width: 148,
      '&:after': {
        display: 'none',
        position: 'absolute',
        content: '""',
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        backgroundColor: STYLE.COLOR.MODAL_BACKDROP,
        backdropFilter: 'blur(4px)',
        zIndex: 1,
        borderRadius: 16,
      },
    },
    pdfPreview: {
      borderRadius: 16,
      height: 148,
      width: 148,
      overflow: 'hidden',
    },
    pdfIframe: {
      border: 'none',
      height: '100%',
      width: '100%',
    },
    pdfPlaceholder: {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
    },
    pdfClickable: {
      cursor: 'pointer',
    },
    pdfFallbackIcon: {
      width: 40,
      height: 48,
      marginTop: 18,
    },
    pdfLabel: {
      fontSize: '12px',
      fontWeight: 600,
      color: STYLE.COLOR.ACCENT_PRIMARY,
    },
    fallbackImage: {
      height: 148,
      width: 148,
      borderRadius: 16,
      objectFit: 'cover',
      border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    },
    imagePreviewLoading: {
      '&:after': {
        display: 'block',
      },
    },
    image: {
      height: 148,
      width: 148,
      borderRadius: 16,
      objectFit: 'cover',
    },
    deleteIconParent: {
      position: 'absolute !important' as any,
      height: 32,
      width: 32,
      top: -12,
      right: -12,
      padding: '0 !important',
    },
    spinner: {
      position: 'absolute !important' as any,
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
      color: `${STYLE.COLOR.WHITE} !important`,
      zIndex: 2,
    },
    requiredMark: {
      color: STYLE.COLOR.ERROR,
      paddingLeft: '3px',
    },
    skippableMark: {
      color: STYLE.COLOR.WARNING,
      paddingLeft: '3px',
    },
    cursorNotAllowed: {
      cursor: 'not-allowed !important',
    },
  }),
);
